import { FilterCriteria, SearchCriteria } from '../../models/searchcriteria.global';
import { SavedSearchOption } from '../../interface/savedsearchoption.interface';

export interface SearchState {
    organizations: {
        // organizationId vs map
        [organizationId: string]: {
            // serviceId vs map
            [serviceId: string]: {
                defaultFilters: {
                    'default-filters': string[];
                    filterCriterias: {
                        [property: string]: FilterCriteria;
                    };
                };
                searchFilters: SavedSearchOption[];
            };
        };
    };
    searchCriteria: {
        [serviceId: string]: {
            instances: {
                // here property can be any generic string, to support enreportmultiple processes screen being displayed simultaneously
                [property: string]: SearchCriteria;
            };
            requests: {
                // making it generic
                [property: string]: SearchCriteria;
            };
            entities: {
                // <entityUid>: SearchCriteria
                [property: string]: SearchCriteria;
            };
        };
    };
}

export const searchState: SearchState = {
    organizations: {},
    searchCriteria: {},
};
